import classNames from 'classnames'
import { forwardRef } from 'react'
import { MagnifyingGlassIcon } from '../../icon'
import { BaseInput, InputSize } from '../base'
import styles from './SearchInput.module.scss'
import type { SearchInputProps} from './types'
import { SearchSize } from './types'

export { InputVariant } from '../base'

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({ size, className, ...rest }, ref) => {
  const mapSize = (size?: SearchSize) => {
    switch (size) {
      case SearchSize.small:
        return InputSize.xsmall
      case SearchSize.medium:
        return InputSize.small
      default:
        return InputSize.medium
    }
  }
  return (
    <BaseInput
      ref={ref}
      {...rest}
      size={mapSize(size)}
      className={classNames([className, styles['search-input']])}
      leadingIcon={MagnifyingGlassIcon}
    />
  )
})
SearchInput.displayName = 'SearchInput'
export default SearchInput
